import styles from "./NavBar.module.css";

export function NavBar() {
   return <nav className={styles.wrap}></nav>;
}
